<template>
  <div class="octobus__columns passenger-bus">
    <div class="octobus__column is-hidden-tablet">
      <div class="octobus__columns is-mobile is-vcentered">
        <div class="octobus__column">
          <p class="bus-route has-text-weight-semibold is-hidden-tablet">{{route}}</p>
        </div>
        <div class="octobus__column has-text-right">
          <Price :price="price" />
        </div>
      </div>
    </div>
    <div class="octobus__column">
      <div class="octobus__dropdown-wrapper" :class="{'is-active': showBus}" @click="toggleBus(true)"></div>
      <div class="octobus__dropdown" :class="{'is-active': showBus}">
        <div class="octobus__dropdown-trigger">
          <button
            class="octobus__button people is-medium is-fullwidth"
            :class="{
              'is-primary is-outlined': seatsSelected.num,
              'is-danger is-outlined': errors.has(`passenger__place_${raceId}`),
            }"
            aria-haspopup="true"
            aria-controls="people"
            @click="toggleBus"
          >
            <span class="octobus__icon is-small">
              <font-awesome-icon
                :icon="busIcon"
              />
            </span>
            <span>{{getButtonLabel}}</span>
            <input
              type="text"
              v-show="false"
              :value="getPlace"
              v-validate="'required'"
              :id="`passenger__place_${raceId}`"
              :name="`passenger__place_${raceId}`"
            />
            <span class="octobus__icon is-small is-hidden-tablet" v-show="selectedSeat">
              {{seatsSelected.num}}
            </span>
          </button>
        </div>
        <div class="octobus__dropdown-menu" id="people" role="menu">
          <div class="octobus__dropdown-content">
            <div class="octobus__dropdown-item">
              <template v-if="!busTemplate">
                <div class="bus">
                  <div v-for="(row, index) in seats" :key="index" class="seats-row">
                    <div
                      class="seat octobus__columns is-vcentered"
                      v-for="seat in row"
                      :key="seat.id"
                      :class="{
                        'empty': seat.empty,
                        'seat-free': seat.free,
                        'selected': seat.selected,
                        'seat-disabled': !seat.free,
                        'second-side': seat.secondSide,
                      }"
                      @click="setSeat(seat.number, seat.free, seat.selected)"
                    >
                      {{seat.number}}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="floor" v-if="busTemplate.matrix && busTemplate.matrix.length > 1">
                  <span
                    v-for="(_, index) in busTemplate.matrix"
                    :class="{'floor--btn': true, active: floor === index + 1}"
                    :key="index"
                    @click="setFloor(index + 1)"
                  >{{ $t('bus.floor', { floor: index + 1 }) }}</span>
                </div>
                <div class="bus">
                  <div v-for="(row, index) in seatsTempl" :key="index" class="seats-row">
                    <div
                      class="seat octobus__columns is-vcentered"
                      v-for="seat in row"
                      :key="seat.id"
                      :class="{
                        'empty': seat.empty,
                        'seat-free': seat.free,
                        'selected': seat.selected,
                        'seat-disabled': !seat.free,
                        'second-side': seat.secondSide,
                      }"
                      @click="setSeat(seat.number, seat.free, seat.selected)"
                    >
                      <span v-if="!seat.empty" class="seat--chair">
                        <svg-icon name='chair' width="40" height="40" :color="getColourForSeat(seat)" />
                      </span>
                      <span class="seat--number">{{seat.number}}</span>
                      </div>
                  </div>
                  <div class="seats-row--first" v-if="checkFirstPlace()">
                    <svg-icon name='wheel' width="40" height="40" color="r-#ccc" />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="octobus__column">
      <div class="octobus__columns is-mobile is-vcentered">
        <div class="octobus__column">
          <p>
            <span
              class="selected-seat-show is-size-5 is-hidden-mobile"
              v-show="selectedSeat"
            >
              {{selectedSeat}}
            </span>
            <span class="bus-route is-size-6 has-text-grey is-hidden-touch">{{route}}</span>
          </p>
          <p class="is-size-7 is-hidden-touch">{{$t('bus.carrier', { carrier: carrier })}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faBus } from '@fortawesome/fontawesome-free-solid';
import get from 'lodash/get';
import filter from 'lodash/filter';

import Price from './Price';
import Seat from './Seat';

export default {
  name: 'Bus',
  inject: ['$validator'],
  components: {
    FontAwesomeIcon,
    Price,
  },
  props: {
    carrier: {
      type: String,
      required: true,
    },
    departure: {
      type: String,
      required: true,
    },
    arrived: {
      type: String,
      required: true,
    },
    places: {
      type: Array,
      required: true,
    },
    raceId: {
      type: [String],
      required: true,
    },
    busCapacity: {
      type: Number,
      required: true,
    },
    busTemplate: {},
    price: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showBus: false,
      seatsSelected: {},
      floor: 1,
    };
  },
  methods: {
    checkFirstPlace() {
      const index = this.floor - 1;
      const floor = get(this, `busTemplate.matrix[${index}]`, []);

      return floor.some(row => row.some(item => item.n === 1));
    },
    getColourForSeat(seat) {
      if (seat.free) { return 'r-#777'; }
      if (!seat.free) { return 'r-#ccc'; }
      if (seat.selected) { return 'r-#65BB69'; }

      return 'r-#777';
    },
    toggleBus(off) {
      this.showBus = (off === true) ? false : !this.showBus;
    },
    setSeat(value, isFree, isSelected) {
      if (isFree && !isSelected) {
        this.seatsSelected = { num: value };
        this.showBus = false;
      } else if (isSelected && isFree) {
        this.seatsSelected = {};
      }

      this.$validator.validate(`passenger__place_${this.raceId}`, this.seatsSelected);
      this.$emit('selectedPlace', this.seatsSelected, this.raceId);
    },
    setFloor(floor) {
      this.floor = floor;
    },
  },
  computed: {
    route() {
      return `${this.departure} - ${this.arrived}`;
    },
    busIcon() {
      return faBus;
    },
    selectedSeat() {
      const num = this.seatsSelected.num;

      if (num) {
        return `${num} место`;
      }

      return '';
    },
    getPlace() {
      return this.seatsSelected.num ? this.seatsSelected.num : '';
    },
    getButtonLabel() {
      return this.seatsSelected.num ? this.$t('bus.change') : this.$t('bus.choise');
    },
    seats() {
      const rows = [];
      let cSeat = 1;

      while (this.busCapacity >= cSeat) {
        const row = [];

        for (let i = 0; i < 4; i += 1) {
          const secondSide = i === 2;
          const seat = new Seat(cSeat, this.raceId);
          const isFree = Boolean(filter(this.places, { num: seat.number }).length);
          const isSelected = this.seatsSelected.num === cSeat;
          const isEmpty = !(this.busCapacity >= cSeat);

          seat.secondSide = secondSide;
          seat.isSelected = isSelected;
          seat.isFree = isFree;
          seat.isEmpty = isEmpty;

          row.push(seat);
          cSeat += 1;
        }

        rows.push(row);
      }

      return rows.reverse();
    },
    seatsTempl() {
      const rows = [];
      const templFloor = this.busTemplate.matrix[this.floor - 1];
      const { x, y } = this.busTemplate.size[this.floor - 1];

      for (let i = 0; i < x; i += 1) {
        const row = [];

        for (let k = 0; k < y; k += 1) {
          const templSeat = templFloor[k][i];
          const seat = new Seat(templSeat.n, this.raceId);
          const isFree = Boolean(filter(this.places, { num: seat.number }).length);
          const isSelected = (this.seatsSelected.num === templSeat.n) && seat.number;
          const isEmpty = !seat.number;

          seat.isSelected = isSelected;
          seat.isFree = isFree;
          seat.isEmpty = isEmpty;

          row.push(seat);
        }

        rows.push(row.reverse());
      }

      return rows.reverse();
    },
  },
  filters: {
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
#app, #auth {
  .octobus__dropdown-wrapper.is-active {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 8;
  }

  .octobus__dropdown {
    // z-index: 9;
    width: 100%;

    .octobus__dropdown-trigger {
      width: 100%;
    }
  }

  .bus {
    display: inline-flex;
    margin-top: 10px;
    padding: 20px 15px 20px 25px;
    border-radius: 8px;
    border: 1px solid #ccc;
    padding: 20px;

    .seat {
      width: 40px;
      max-width: 40px;
      height: 40px;
      max-height: 40px;
      margin: 2px;
      color: #ccc;
      fill: #ccc;
      overflow: hidden;
      position: relative;

      .seat--chair{
        max-height: 40px;
        line-height: 40px;
      }

      .seat--number {
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        position: absolute;
        left: 58%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      &.seat-free {
        cursor: pointer;
      }

      &.seat-disabled {
        cursor: not-allowed;
      }

      &.empty {
        border: none;
      }

      &.selected /deep/ .seat--chair svg > path {
        fill: #65BB69;
      }
    }

    .seats-row {
      display: flex;
    }

    .seats-row--first {
      display: block;
      margin: 3px;
    }
  }

  .floor--btn {
    padding: 6px;
    border: 1px solid #dbdbdb;
    margin: 0 10px;
    cursor: pointer;

    &.active {
      border: 1px solid #f59400;
    }
  }
}

@media only screen and (min-width : 768px) {
  #app, #auth {
    .seats-row {
      flex-direction: column;
      justify-content: space-around;
    }
  }
}

/* Small Devices, Tablets */
@media only screen and (max-width : 768px) {
  #app, #auth {
    .bus {
      flex-direction: column-reverse;
      padding: 10px 25px 10px 25px;

      .second-side {
        margin-top: 5px;
        margin-left: 33px;
      }

      .seats-row--first svg {
        transform: rotate(-90deg);
      }

      .seat {
        svg {
          transform: rotate(-90deg);
        }

        .seat--number {
          left: 50%;
        }
      }
    }

    .selected-seat-show {
      margin-right: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Passenger/Bus.vue